import { envConfig } from 'config/env-config';
import { EnhancedWindow } from 'models/Window';

import { getAccessToken } from '../../../interceptors/auth0.interceptor';

const verifyCustomerSetup = async (): Promise<boolean> => {
  const accessToken = await getAccessToken({
    audience: 'https://digitalapi.auspost.com.au/medium',
    scope: 'https://scopes.auspost.com.au/auth/mpc/consumer.readwrite',
  });
  if (!accessToken) return false;
  const CUSTOMER_SIGNUP_CONFIG = {
    env: {
      envUrl: envConfig.url,
      envApiGateway: envConfig.layerSeven, // e.g. digitalapi.auspost.com.au
    },
    caller: 'TRACK',
    accessToken,
  };
  const eWindow = window as EnhancedWindow;
  const verified = await eWindow.__AUSPOST__?.customerSignupService?.verifyCustomer(CUSTOMER_SIGNUP_CONFIG);
  return !!verified;
};

export default { verifyCustomerSetup };
